// extracted by mini-css-extract-plugin
export default {"container":"CurrencySelectSkeleton_container__RWSHk","skeleton":"CurrencySelectSkeleton_skeleton__D5wLW"};